import { render, staticRenderFns } from "./CardServiceRequest.vue?vue&type=template&id=04feeb61&scoped=true&"
import script from "./CardServiceRequest.vue?vue&type=script&lang=js&"
export * from "./CardServiceRequest.vue?vue&type=script&lang=js&"
import style0 from "./CardServiceRequest.vue?vue&type=style&index=0&id=04feeb61&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04feeb61",
  null
  
)

export default component.exports